module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-403.8cc98db.woff2";